import React, { Suspense, lazy } from "react";
import { useSelector } from "react-redux";
import { Routes, Route, Navigate } from "react-router-dom";
import "./index.scss";
import { RestrictedRoutes } from "./Routes/RestrictedRoutes";
import { PrivateRoutes } from "./Routes/PrivateRoutes";
import { CustomToast } from "./common/CommonToast/toast";
// import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import Loading from "./components/Loading/Loading";

// Lazy load route components for code splitting
const LoginPage = lazy(() => import("./pages/public/login.page"));
const ForgotPassPage = lazy(() => import("./pages/public/forgot-password.page"));
const ResetPassPage = lazy(() => import("./pages/public/reset-password.page"));

const DashboardPage = lazy(() => import("./pages/authorized/dashboard/dashboard.page"));
const ThirdPartyKeysStatesPage = lazy(() => import("./pages/authorized/thirdPartyKeys/keysStates.page"));

const SecuritySettingsPage = lazy(() => import("./pages/authorized/settings/security.page"));
const UserNotificationAlertSettingsPage = lazy(() => import("./pages/authorized/settings/userNotificationAlert.page"));

const CoinsListPage = lazy(() => import("./pages/authorized/coins/coinsList.page"));
const CoinsSyncPage = lazy(() => import("./pages/authorized/coins/coinsSync.page"));
const VendersPage = lazy(() => import("./pages/authorized/vender/vendersList.page"));
const VenderDetailsPage = lazy(() => import("./pages/authorized/vender/venderDetails.page"));

const ThirdPartyKeysListPage = lazy(() => import("./pages/authorized/thirdPartyKeys/keysList.page"));

const PlansList = lazy(() => import("./pages/authorized/apiHitsPlansList/plansList.page"));
const CacheDashboardPage = lazy(() => import("./pages/authorized/cache/cacheDashboard.page"));

// Loading fallback component for route code splitting
const LoadingFallback = () => <Loading fullScreen tip="Loading page..." />;

function App() {
   const { success, message, error } = useSelector((state) => state?.toastState);
   const isAdmin = useSelector((state) => state.userState?.user?.role) === "admin";

   return (
      <>
         {/* ErrorBoundary */}
         <CustomToast success={success} error={error} message={message} />
         <Suspense fallback={<LoadingFallback />}>
            <Routes>
               <Route path="/" element={<RestrictedRoutes />}>
                  <Route path="/" element={<LoginPage />} />
                  <Route path="/forgot-password" element={<ForgotPassPage />} />
                  <Route path="/reset-pass/:id" element={<ResetPassPage />} />
               </Route>

               <Route path="/" element={<PrivateRoutes />}>
                  <Route path="/dashboard" index element={<DashboardPage />} />

                  <Route path="/venders-list" element={<VendersPage />} />
                  <Route path="/vender-details/:id" element={<VenderDetailsPage />} />

                  <Route path="/third-party-keys/keylist" element={<ThirdPartyKeysListPage />} />
                  <Route path="/third-party-keys/states" element={<ThirdPartyKeysStatesPage />} />

                 <Route path="/coin-list" element={<CoinsListPage />} />
                 <Route path="/coins/sync" element={<CoinsSyncPage />} />
                  <Route path="/planslist" element={<PlansList />} />
                  <Route path="/cache-dashboard" element={isAdmin ? <CacheDashboardPage /> : <Navigate to="/dashboard" replace />} />

                  <Route path="/settings/security" element={<SecuritySettingsPage />} />
                  <Route path="/settings/users-alert" element={<UserNotificationAlertSettingsPage />} />
               </Route>
            </Routes>
         </Suspense>
      </>
   );
}
export default App;
